import { useFormContext } from 'react-hook-form';
import type { ReactElement } from 'react';
import { CustomizableErrorView } from '../errors/ErrorView';
import { FORM_API_ERROR_FIELD, type FormApiError } from './UseGraphQLApiError';

export const GraphQLApiFormErrorMessage = (): ReactElement | null => {
  const {
    formState: { errors },
  } = useFormContext();

  const apiError = errors[FORM_API_ERROR_FIELD] as FormApiError | undefined;

  return apiError ? <CustomizableErrorView cause={apiError} content={apiError.message} variant="inline" /> : null;
};
